import {
  AnalyticsEvent,
  DiscoverMorePageTile,
  DiscoverMoreProductRowTile,
  Maybe,
} from '@varo/graphql-schema-types';
import { IconKeyType } from 'shared/components/vxl/icon/Icon/Icon';
import { ListItemGroupItem } from 'shared/components/vxl/ListItemGroup/ListItemGroup';
import { VXLComponentId } from 'shared/renderer/types';

export interface DiscoverMoreItem extends ListItemGroupItem {
  onClickAnalytics?: Maybe<AnalyticsEvent>;
}

export interface DiscoverMoreAdapterResult {
  title: string;
  displayAnalytics?: Maybe<AnalyticsEvent>;
  sections: Array<{
    id: string;
    sectionLabel: string;
    items: DiscoverMoreItem[];
  }>;
}

const PRODUCT_TYPE_ICONS: Record<string, IconKeyType> = {
  SAVINGS_ACCOUNT: 'PIGGY_BANK',
  BELIEVE_CARD: 'CREDIT_SCORE',
  DIRECT_DEPOSIT: 'CALENDAR',
  VARO_ADVANCE: 'DEPOSIT_CASH',
  LINE_OF_CREDIT: 'LOAN',
  PAY_OVER_TIME: 'MONEY',
};

const mapProductRowToItem = (
  row: DiscoverMoreProductRowTile,
): DiscoverMoreItem => {
  const iconKey = PRODUCT_TYPE_ICONS[row.productType];

  return {
    keyId: row.productType,
    primaryCopy: row.title,
    secondaryCopy: row.description ?? null,
    onClickAnalytics: row.onClickAnalytics,
    leadingAccessory: iconKey
      ? {
          id: 'icon',
          name: VXLComponentId.ICON,
          props: {
            iconKey,
          },
        }
      : null,
    showsChevron: true,
  };
};

export const discoverMoreAdapter = (
  discoverMorePage: DiscoverMorePageTile,
): DiscoverMoreAdapterResult => {
  const sections: DiscoverMoreAdapterResult['sections'] = [];

  if (discoverMorePage.topSection?.length > 0) {
    sections.push({
      id: 'topSection',
      sectionLabel: '',
      items: discoverMorePage.topSection.map(mapProductRowToItem),
    });
  }

  if (discoverMorePage.middleSection?.length > 0) {
    sections.push({
      id: 'middleSection',
      sectionLabel: 'Borrowing',
      items: discoverMorePage.middleSection.map(mapProductRowToItem),
    });
  }

  return {
    title: discoverMorePage.title,
    displayAnalytics: discoverMorePage.displayAnalytics,
    sections,
  };
};

export default discoverMoreAdapter;
